import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, useSlots, withDefaults } from "vue";
import { PanelCardProps } from "@/types";
import {
  Typography,
  Icon,
  Separator,
  FlexBox,
} from "@/components/common/display";
import IconButton from "@/components/common/button/IconButton.vue";


/**
 * Displays a card that contains panel content.
 */
const __default__ = {
  name: "PanelCard",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: { default: undefined },
    subtitle: { default: undefined },
    containerClass: { default: "" },
    minimal: { type: Boolean },
    collapsable: { type: Boolean },
    borderless: { type: Boolean, default: false },
    color: { default: "border" },
    icon: { default: undefined },
    class: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const slots = useSlots();

const expanded = ref(true);

const color = computed(() => (props.minimal ? "transparent" : props.color));

const padding = computed(() => {
  if (props.borderless) {
    return "q-px-md";
  } else if (props.minimal) {
    return "q-pa-xs";
  } else {
    return "q-pa-md";
  }
});

const className = computed(
  () =>
    `overflow-hidden bg-neutral ${padding.value} ` +
    (props.borderless ? " " : `bd-${color.value} `) +
    props.class
);

const containerClassName = computed(() => `q-mb-md ${props.containerClass}`);

return (_ctx: any,_cache: any) => {
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(containerClassName.value)
  }, [
    _createVNode(_component_q_card, {
      flat: "",
      class: _normalizeClass(className.value)
    }, {
      default: _withCtx(() => [
        (!props.minimal)
          ? (_openBlock(), _createBlock(_unref(FlexBox), {
              key: 0,
              align: "center",
              justify: "between"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FlexBox), {
                  align: "center",
                  class: "overflow-hidden"
                }, {
                  default: _withCtx(() => [
                    (!!props.icon)
                      ? (_openBlock(), _createBlock(_unref(Icon), {
                          key: 0,
                          variant: props.icon,
                          class: "q-mr-sm",
                          size: "lg",
                          color: "primary"
                        }, null, 8, ["variant"]))
                      : _createCommentVNode("", true),
                    (!!props.title)
                      ? (_openBlock(), _createBlock(_unref(Typography), {
                          key: 1,
                          variant: "subtitle",
                          el: "h2",
                          value: props.title,
                          ellipsis: ""
                        }, null, 8, ["value"]))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "title")
                  ]),
                  _: 3
                }),
                (props.collapsable || !!_unref(slots)['title-actions'])
                  ? (_openBlock(), _createBlock(_unref(FlexBox), {
                      key: 0,
                      align: "center"
                    }, {
                      default: _withCtx(() => [
                        (!props.collapsable || expanded.value)
                          ? _renderSlot(_ctx.$slots, "title-actions", { key: 0 })
                          : _createCommentVNode("", true),
                        (props.collapsable)
                          ? (_openBlock(), _createBlock(IconButton, {
                              key: 1,
                              small: "",
                              tooltip: "Toggle expanded",
                              icon: expanded.value ? 'up' : 'down',
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
                            }, null, 8, ["icon"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 3
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            }))
          : _createCommentVNode("", true),
        (!props.minimal && (!!props.title || !!_unref(slots).title) && expanded.value)
          ? (_openBlock(), _createBlock(_unref(Separator), {
              key: 1,
              b: "2"
            }))
          : _createCommentVNode("", true),
        (!props.minimal && !!props.subtitle && expanded.value)
          ? (_openBlock(), _createBlock(_unref(Typography), {
              key: 2,
              el: "p",
              b: "4",
              value: props.subtitle,
              secondary: ""
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (expanded.value)
          ? _renderSlot(_ctx.$slots, "default", { key: 3 })
          : _createCommentVNode("", true),
        (!!_unref(slots).actions)
          ? (_openBlock(), _createBlock(_component_q_card_actions, { key: 4 }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "actions")
              ]),
              _: 3
            }))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["class"])
  ], 2))
}
}

})